import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FilterService {
    private filters: any;
    private readonly storageKey = 'redirectNav';

    setFilters(filters: any) {
        let cleanedFilters;

        if (filters.getRawValue) {
            cleanedFilters = filters.getRawValue();
        } else {
            cleanedFilters = JSON.parse(JSON.stringify(filters, this.getCircularReplacer()));
        }

        this.filters = cleanedFilters;
        sessionStorage.setItem('productFilters', JSON.stringify(cleanedFilters));
    }

    getFilters() {
        const savedFilters = sessionStorage.getItem('productFilters');
        if (savedFilters) {
            this.filters = JSON.parse(savedFilters);
        }
        return this.filters;
    }

    getCircularReplacer() {
        const seen = new WeakSet();
        return (key: any, value: any) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                seen.add(value);
            }
            return value;
        };
    }

    clearFilters() {
        this.filters = null;
        sessionStorage.removeItem('productFilters');
    }

    clearSessionStorage(){
        sessionStorage.clear()
    }

    setIsClickNav(value: boolean): void {
        sessionStorage.setItem(this.storageKey, JSON.stringify(value));
    }

    getIsClickNav(): boolean {
        const item = sessionStorage.getItem(this.storageKey);
        return item ? JSON.parse(item) : false;
    }
}
